import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import auth from "../middlewares/auth";
import checkAdmin from "../middlewares/admin";
import ResetPassword from "../views/ResetPassword.vue";
import ResettingPassword from "../views/ResettingPassword";
import DeviceNotAuthorized from "../views/DeviceNotAuthorized.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/forgot_password",
    name: "senha",
    component: ResetPassword
  },
  {
    path: "/reset_password/:token",
    name: "recuperar",
    component: ResettingPassword
  },
  {
    path: "/device_not_authorized",
    name: "deviceNotAuthorized",
    component: DeviceNotAuthorized
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "/",
        name: "dashboard",
        component: () => import("../views/Dashboard.vue")
      },
      {
        path: "clientes",
        name: "clients",
        component: () => import("../views/Clients.vue")
      },
      {
        path: "clientes/:id",
        name: "pagina_cliente",
        component: () => import("../views/PaginaCliente.vue")
      },
      {
        path: "produtos",
        name: "products",
        component: () => import("../views/Products.vue")
      },
      {
        path: "users",
        name: "users",
        component: () => import("../views/Users.vue"),
        beforeEnter: checkAdmin
      },
      {
        path: "perfil",
        name: "perfil",
        component: () => import("../views/Profile.vue")
      },
      {
        path: "/pedidos",
        name: "pedidos",
        component: () => import("../views/Pedidos.vue")
      },
      {
        path: "/devolucoes/nova",
        name: "nova_devolucao",
        component: () => import("../views/NovaDevolucaoForm.vue")
      },
      {
        path: "/devolucoes",
        name: "devolucoes",
        component: () => import("../views/Devolucoes.vue")
      },
      {
        path: "/devolucoes/:numero",
        name: "devolucao_page",
        component: () => import("../views/DevolucaoPage.vue")
      },
      {
        path: "/sales/new",
        name: "new_sale",
        component: () => import("../views/SaleForm.vue")
      },
      {
        path: "/pedidos/new",
        name: "new_pedido",
        component: () => import("../views/PedidoForm.vue")
      },
      {
        path: "/pedidos/:numero",
        name: "edit_pedido",
        component: () => import("../views/PedidoForm.vue")
      },
      {
        path: "relogio_de_ponto",
        name: "relogio_de_ponto",
        component: () => import("../views/RelogioDePonto.vue")
      },
      {
        path: "authorized_devices",
        name: "authorized_devices",
        component: () => import("../views/AuthorizedDevices.vue"),
        beforeEnter: checkAdmin
      }
    ]
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "*",
    component: Home,
    beforeEnter: (to, from, next) => {
      next("/");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
